import {ReactNode} from 'react'
import {BallotProvider} from '../context/ballot'
import {VoterProvider} from '../context/voter'
import {Ballot} from '../types/ballot'

interface BallotVoterProviderProps {
  initBasicBallot?: Ballot | null
  children: ReactNode
}

export const BallotVoterProvider = ({
  initBasicBallot,
  children,
}: BallotVoterProviderProps) => {
  return (
    <BallotProvider
      initBasicBallot={initBasicBallot}
    >
      <VoterProvider
        ballotId={initBasicBallot?._id}
        customerId={initBasicBallot?.customer?._id}
      >
        {children}
      </VoterProvider>
    </BallotProvider>
  )
}
